import React, { FunctionComponent, useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps
} from "@material-ui/core";
import { ProductSpoilageReason } from "../../models/Product";
import { useSelector } from "react-redux";
import { AppState } from "../../store";
import { useLoadIfEmpty } from "../../hooks/useLoadIfEmpty";
import { thunkFetchSpoilageReasons } from "../../store/products/action";

interface SpoilageReasonSelectProps extends Omit<SelectProps, "loading"> {
  label?: string;
  onSelected?: (value: ProductSpoilageReason) => void;
  variant?: "filled" | "outlined" | "standard";
  error?: boolean;
}

export const SpoilageReasonSelect: FunctionComponent<
  SpoilageReasonSelectProps
> = ({
  label = "Reason",
  onSelected,
  variant = "standard",
  onChange,
  error = false,
  ...props
}) => {
  const reasons =
    useSelector<AppState, ReadonlyArray<ProductSpoilageReason>>(
      s => s.storeClusterProducts.spoilageReasons
    ) || [];
  const [state, setState] = useState<ReadonlyArray<ProductSpoilageReason>>([]);
  const [selected, setSelected] = useState<any>("");

  useLoadIfEmpty(!reasons.length, thunkFetchSpoilageReasons);

  const handleChange = (event: any, child: any) => {
    setSelected(event.target.value);
    if (onSelected) {
      let reason = state.find(s => s.id === event.target.value);
      if (reason) {
        onSelected(reason);
      }
    }
    if (onChange) {
      onChange(event, child);
    }
  };

  useEffect(() => {
    setState(reasons);
  }, [reasons]);

  return (
    <FormControl variant={variant} className={props.className} error={error}>
      <InputLabel
        id="spoilage-reason-select-label"
        style={
          variant === "outlined"
            ? {
                backgroundColor: "#fff",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem"
              }
            : undefined
        }
      >
        {label}
      </InputLabel>
      <Select
        onChange={handleChange}
        labelId="spoilage-reason-select-label"
        id="spoilage-reason-select"
        autoWidth={true}
        value={selected || ""}
      >
        {state &&
          state.length > 0 &&
          state.map(reason => (
            <MenuItem key={reason.id} value={reason.id}>
              {reason.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
